import React from 'react'
import styled from 'styled-components'

import { Spinner, Text } from 'components'

type Props = {
  message?: string
}

const TransitionPage: React.FC<Props> = ({ message }) => (
  <Container>
    <Spinner fontSize={80} />
    <Text fontSize="18px" fontWeight="bold">
      {message}
    </Text>
  </Container>
)

export default TransitionPage

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
`
